/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import Home from './Home';
import ServicesLayout from '../../components/ServicesLayout';

export default {

  path: '/',

  async action(ctx) {
    const state = await ctx.store.getState();
    return {
      title: "Strona główna - e-spdp.pl",
      component: <ServicesLayout active="main"><Home /></ServicesLayout>,
      description: "Strona główna portalu przygotowanego z myślą o mieszkańcach poszczególnych gmin oraz przedsiębiorcach rozwijających swoją działalność na tych obszarach. Dzięki temu portalowi załatwienie sprawy jest możliwe całkowicie poprzez drogę elektroniczną.",
    }
  },
};



// WEBPACK FOOTER //
// src/routes/home/index.js